import { Component,
         Output,
         EventEmitter }               from '@angular/core';
import { TableColumn,
         TableColumnType }            from './../common/table-column';
import { TrainClassService }          from './../shared/train-class.service';
import { TrainClassSortableFilter }   from './train-class-list-sortable-filter';
import { TrainClassDialogComponent }  from './../train-class-dialog/train-class-dialog.component';
import { MatDialog, MatSnackBar }     from '@angular/material';
import { Globals }                    from './../common/globals';
import { SavingDialogComponent }      from '../common/saving-dialog.component';


@Component({
  selector: 'sa-train-class-list',
  template: require('./train-class-list.component.html'),
  styles: [require('./train-class-list.component.scss')]
})
export class TrainClassListComponent {

  @Output() filter = new TrainClassSortableFilter('className');
  @Output() performSearch = new EventEmitter();
  @Output() columns: Array<TableColumn>;
  @Output() service: TrainClassService;

  public error: string;

  public getDataCallback: Function;

  constructor(
    trainClassService: TrainClassService,
    public dialog: MatDialog,
    public globals: Globals,
    private snackbar: MatSnackBar
  ) {
     this.getDataCallback = this.getData.bind(this);
     this.service = trainClassService;

    this.columns = [
      new TableColumn(TableColumnType.Number, 'trainClassID', 'ID', 50),
      new TableColumn(TableColumnType.Text, 'className', 'Jméno', 350),
      // new TableColumn(TableColumnType.Bool, 'active', 'Aktivní', 250)
    ];

    this.performSearch.emit(this.filter);
  }

  public search() {
    this.performSearch.emit(this.filter);
  }

  public addNew() {

    let snack = this.snackbar;
    let dialogRef = this.dialog.open(TrainClassDialogComponent);
    dialogRef.componentInstance.model = {};
    dialogRef.componentInstance.newItem = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.service.insertItem(dialogRef.componentInstance.model)
        .subscribe(
            res => {
              cloakRef.close();
              snack.open('Úspěšně uloženo.', '', {duration: 2000});
              this.search();
            },
            err => {
              cloakRef.close();
              snack.open(err.message, '', {duration: 2000});
            });
      }
    });
  }

  private getData(filter: TrainClassSortableFilter) {
      return this.service.getItems(filter);
  }

  filterChanged(event) {
      this.performSearch.emit(this.filter);
  }

  editItem(model) {
    let dialogRef = this.dialog.open(TrainClassDialogComponent);
    dialogRef.componentInstance.model = model;
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        this.service.insertItem(dialogRef.componentInstance.model)
          .subscribe(res => {
            console.log('TrainClass updated');
            this.performSearch.emit(this.filter);
          });
      } else if (result === 'delete') {
        this.service.deleteItem(dialogRef.componentInstance.model.trainClassID)
          .subscribe(res => {
            console.log('TrainClass deleted');
            this.performSearch.emit(this.filter);
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-class-list/train-class-list.component.ts